<div class="row">
  <div class="col-12">
    <div *ngIf="caso?.anomalias" class="alert alert-warning" role="alert" style="background-color: #fdefcb;">
      <i class="me-2 mdi mdi-block-helper" style="color: #d4a017;"></i>
      <span i18n style="color: #d4a017;">Este caso presenta incoherencias en algunos datos. Puede ver más detalles en la
        sección de Inicio. </span>
    </div>
    <div class="card">
      <div class="card-body">
        <ul ngbNav #nav="ngbNav" [(activeId)]="currentSection" [class.mb-3]="currentSection !== 3"
          [class.mb-1]="currentSection === 3" class="nav-pills bg-light custom-nav form-wizard-header">
          <li [ngbNavItem]="1" class="flex-grow-item wider">
            <a ngbNavLink class="rounded-0 pt-2 pb-2">
              <i class="mdi mdi-home me-1"></i>
              <span class="d-none d-sm-inline">{{ nombreCaso }}</span>
            </a>
            <ng-template ngbNavContent>
              <app-inicio></app-inicio>
            </ng-template>
          </li>
          <li [ngbNavItem]="2" class="flex-grow-item">
            <a ngbNavLink class="rounded-0 pt-2 pb-2">
              <i class="mdi mdi-account-circle me-1"></i>
              <span class="d-none d-sm-inline" i18n>Caract. generales</span>
            </a>
            <ng-template ngbNavContent>
              <ul ngbNav #innerNav="ngbNav" [(activeId)]="innerCurrentSection" class="nav nav-tabs nav-bordered"
                role="tablist">
                <li [ngbNavItem]="1">
                  <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 1" i18n>Info general</a>
                  <ng-template ngbNavContent>
                    <app-info-general (refreshCase)="refrescarCaso()"></app-info-general>
                  </ng-template>
                </li>
                <li [ngbNavItem]="2" (click)="partesView = 'list'">
                  <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 2" i18n>Partes</a>
                  <ng-template ngbNavContent>
                    <ng-container *ngIf="partesView === 'list'">
                      <app-list-partes (changePartesView)="onChangePartesView($event)"
                        (refreshCase)="refrescarCaso()"></app-list-partes>
                    </ng-container>
                    <ng-container *ngIf="partesView === 'edit'">
                      <app-detail-parte [parteId]="selectedParteId"
                        (changePartesView)="onChangePartesView($event)"></app-detail-parte>
                    </ng-container>
                    <ng-container *ngIf="partesView === 'new'">
                      <app-new-parte (changePartesView)="onChangePartesView($event)"></app-new-parte>
                    </ng-container>
                    <ng-container *ngIf="partesView === 'representantes'">
                      <app-representantes (changePartesView)="onChangePartesView($event)"
                        [parteId]="selectedParteId"></app-representantes>
                    </ng-container>
                  </ng-template>
                </li>

                <li [ngbNavItem]="3" (click)="partesView = 'list'">
                  <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 3" i18n>Tribunal</a>
                  <ng-template ngbNavContent>
                    <app-gestion-tribunal (refreshCase)="refrescarCaso()"></app-gestion-tribunal>
                  </ng-template>
                </li>

                <li [ngbNavItem]="4">
                  <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 4" i18n>Institución</a>
                  <ng-template ngbNavContent>
                    <app-gestion-institucion (refreshCase)="refrescarCaso()"></app-gestion-institucion>
                  </ng-template>
                </li>
                <li [ngbNavItem]="5">
                  <a ngbNavLink class="nav-link" [class.active]="innerCurrentSection === 5" i18n>Características del
                    arbitraje</a>
                  <ng-template ngbNavContent>
                    <app-caracteristicas-arbitraje (refreshCase)="refrescarCaso()"></app-caracteristicas-arbitraje>
                  </ng-template>
                </li>
              </ul>
              <div [ngbNavOutlet]="innerNav" class="tab-content mt-3"></div>
            </ng-template>
          </li>

          <li [ngbNavItem]="3" class="flex-grow-item">
            <a ngbNavLink class="rounded-0 pt-2 pb-2 custom-nav-link">
              <i class="mdi mdi-folder me-1"></i>
              <span class="d-none d-sm-inline" i18n>Archivos</span>
            </a>
            <ng-template ngbNavContent>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [id]="id_caso"
                  name="enviar_email_subida_archivo" [checked]="caso['enviar_email_subida_archivo']"
                  (change)="onSwitchChange(id_caso)" [disabled]="isCaseClosed() || disableOptions">
                <label class="form-check-label" for="id_caso">
                  <span i18n>Enviar por correo electrónico el resumen diario de archivos subidos</span>
                </label>
              </div>                          
              <app-file-explorer [tipoExplorador]="'expediente'"></app-file-explorer>
            </ng-template>
          </li>
          <li [ngbNavItem]="4" class="flex-grow-item">
            <a ngbNavLink class="rounded-0 pt-2 pb-2 custom-nav-link">
              <i class="mdi mdi-currency-usd me-1"></i>
              <span class="d-none d-sm-inline" i18n>Financiero</span>
            </a>
            <ng-template ngbNavContent>
              <app-gestion-financiero (refreshCase)="refrescarCaso()"></app-gestion-financiero>
            </ng-template>
          </li>
          <li [ngbNavItem]="5" *ngIf="!disableOptions" class="flex-grow-item">
            <a ngbNavLink class="rounded-0 pt-2 pb-2 custom-nav-link">
              <i class="mdi mdi-scale-balance me-1"></i>
              <span class="d-none d-sm-inline" i18n>Hitos procesales</span>
            </a>
            <ng-template ngbNavContent>              
              <app-dias-inhabiles></app-dias-inhabiles>
              <div class="form-check form-switch">
                <input class="form-check-input" type="checkbox" [id]="id_caso"
                  name="enviar_email_hito" [checked]="caso['enviar_email_hito']"
                  (change)="onSwitchChangeHitos(id_caso)">
                <label class="form-check-label" for="id_caso">
                  <span i18n>Enviar por correo electrónico avisos de próximos vencimientos de hitos</span>
                </label>
              </div> 
              <app-hitos-procesales></app-hitos-procesales>
            </ng-template>
          </li>
          <li [ngbNavItem]="6" *ngIf="!disableOptions" class="flex-grow-item">
            <a ngbNavLink class="rounded-0 pt-2 pb-2 custom-nav-link">
              <i class="mdi mdi-cog me-1"></i>
              <span class="d-none d-sm-inline" i18n>Coment. internos</span>
            </a>
            <ng-template ngbNavContent>
              <app-comentarios-internos></app-comentarios-internos>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="nav" class="b-0 mb-0 pt-0"></div>
      </div> <!-- end card-body -->
    </div> <!-- end card-->
  </div> <!-- end col -->
</div> <!-- end row -->
